<template>
  <div
    class="banner-container"
    v-if="!$cookies.get('accept-cookie-policy') && !isBannerClosed"
  >
    <div class="banner-message">
      <p>
        {{ "cookie_banner.message" | translate }}
        <a
          class="cursor"
          href="https://docs.google.com/document/d/e/2PACX-1vQZHpRJyTggjZPwZQW_sw2FIbpsv20qMacrgoFXWhSlqhjCDIxMFqJGMD2ImQKVkGLNDLYcEEyRSpqO/pub"
          download="gyra_privacy_policy.pdf"
        >
          {{ "footer.titles.privacy_policy" | translate }}
        </a>
      </p>
    </div>

    <div class="accept-btn" @click="acceptCookies()">
      {{ "cookie_banner.accept" | translate }}
    </div>
    <div class="accept-btn" @click="declineCookies()">
      {{ "cookie_banner.decline" | translate }}
    </div>
  </div>
</template>

<script>
import { bootstrap } from "vue-gtag";
export default {
  name: "the-cookie-banner",
  data() {
    return {
      isBannerClosed: false
    };
  },
  methods: {
    async acceptCookies() {
      this.$cookies.set("accept-cookie-policy", "true");
      this.closeBanner();
      await bootstrap();
    },
    declineCookies() {
      this.closeBanner();
    },
    closeBanner() {
      this.isBannerClosed = true;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.banner-container {
  z-index: 10000;
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: $gyra-salmon;
  opacity: 0.9;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media (min-width: 600px) {
    flex-direction: row;
  }

  .banner-message {
    flex: 10;
    font-weight: 500;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .accept-btn {
    margin-left: 10px;
    flex: 1;
    border: 1px solid;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-radius: 5px;

    margin-top: 20px;
    max-width: 50%;
    min-width: 100px;

    @media (min-width: 600px) {
      margin-top: 0;
    }
  }
  a {
    cursor: pointer;
  }
}
</style>
